<div class="d-flex flex-column flex-shrink-0 p-3 text-bg-dark" style="width: 280px; height: 95vh; position: fixed;">
    <!-- <a href="/" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none">
      <svg class="bi pe-none me-2" width="40" height="32" aria-hidden="true">
        <use xlink:href="#bootstrap" />
      </svg>
      <span class="fs-4">Exab Ticketing</span>
    </a>
    <hr> -->
    <ul class="nav nav-pills flex-column mb-auto p-0">
      @for(item of menu; track item.link) {
      <li class="nav-item">
        <a [routerLink]="item.link"  [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active" class="nav-link text-white">
          <svg class="bi pe-none me-2" width="16" height="16" aria-hidden="true">
            <use [attr.xlink:href]="'#' + item.icon" />
          </svg>
          {{ item.title | translate }}
        </a>
      </li>
      }
    </ul>
    <hr>
    <div class="dropdown">
      <a href="#" class="d-flex align-items-center text-white text-decoration-none dropdown-toggle"
        data-bs-toggle="dropdown" aria-expanded="false">
        <img src="https://github.com/mdo.png" alt="" width="32" height="32" class="rounded-circle me-2">
        <strong>{{ currentUser?.fullname }}</strong>
      </a>
      <ul class="dropdown-menu dropdown-menu-dark text-small shadow">
        <li><a class="dropdown-item" (click)="logout()">Sign out</a></li>
      </ul>
    </div>
  </div>
